import { logWarn } from "@/lib/log";

// Sound on/off is a UI preference only; kept for the browser session, never anything sensitive.
const KEY = "brynai-sound";
let ctx = null;

export const soundOn = () => sessionStorage.getItem(KEY) !== "off";
export const setSoundOn = (on) => sessionStorage.setItem(KEY, on ? "on" : "off");

function tone(freq, start, dur, type = "sine", gain = 0.12) {
  ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
  const o = ctx.createOscillator();
  const g = ctx.createGain();
  o.type = type;
  o.frequency.value = freq;
  g.gain.setValueAtTime(gain, ctx.currentTime + start);
  g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + start + dur);
  o.connect(g).connect(ctx.destination);
  o.start(ctx.currentTime + start);
  o.stop(ctx.currentTime + start + dur + 0.05);
}

const SOUNDS = {
  correct: () => { tone(660, 0, 0.12); tone(990, 0.1, 0.18); },
  wrong: () => { tone(220, 0, 0.25, "square", 0.06); },
  tick: () => tone(1200, 0, 0.05, "triangle", 0.05),
  start: () => { tone(440, 0, 0.1); tone(660, 0.12, 0.1); tone(880, 0.24, 0.16); },
  win: () => [523, 659, 784, 1047].forEach((f, i) => tone(f, i * 0.13, 0.22, "triangle", 0.1)),
};

export function play(name) {
  if (!soundOn()) return;
  try { SOUNDS[name]?.(); } catch (e) { logWarn("Sound failed", e); }
}
